var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var SweepBug = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.8174 17.8695H12.3131L12.3131 13.4577L4.77083 21L3 19.2292L10.5031 11.726H6.05225V9.2217H10.5031L7.35589 6.07446L9.12673 4.30362L12.3131 7.48999L12.3131 3L14.8174 3V7.41174L17.9255 4.30362L19.6964 6.07445L16.5491 9.2217H21V11.726H16.5491L19.6964 14.8733L17.9255 16.6441L14.8174 13.536V17.8695ZM11.7016 10.5276L13.4724 12.2984L15.2724 10.4984L13.5016 8.72759L11.7016 10.5276Z", fill: color })] })));
});
